<div class="cookie-consent-container">
  <p class="m-0">{{ 'CookieConsent.Description' | translate }}</p>
</div>

<div class="third-party-cookies">
  <div class="p-dialog-header px-0">
    <div class="p-dialog-title">
      {{ 'CookieConsent.ThirdPartyTitle' | translate }}
    </div>
  </div>

  <p class="m-0">
    {{ 'CookieConsent.ThirdPartyDescription' | translate }}
  </p>
</div>

<div class="flex flex-column align-items-end">
  <p-button [icon]="icon"
    iconPos="right"
    [label]="'CookieConsent.Settings' | translate"
    styleClass="p-button-outlined p-button-rounded"
    class="p-2"
    (onClick)="onToggleSettings()" />

  @if (_shouldShowSettings()) {
    <div class="w-full">
      <form [formGroup]="cookieForm">
        <div class="flex flex-column gap-2 mb-2">
          <div class="flex align-items-center">
            <p-checkbox [binary]="true"
              inputId="privacyPolicy"
              id="privacyPolicy"
              [attr.aria-describedby]="'CookieConsent.StrictlyNecessary.Title' | translate"
              formControlName="necessary" />

            <label for="privacyPolicy" class="ml-2">
              {{ 'CookieConsent.StrictlyNecessary.Title' | translate }}
            </label>
          </div>

          <p>{{ 'CookieConsent.StrictlyNecessary.Description' | translate }}</p>

          <p-button [label]="'CookieConsent.FurtherInformation' | translate"
            [attr.aria-describedby]="'CookieConsent.FurtherInformation' | translate"
            class="p-0"
            styleClass="p-button-link-primary p-0"
            (onClick)="onFurtherInformation(ECookieTypes.StrictlyNecessary)" />
        </div>
      </form>
    </div>
  }
</div>
